/**
 * @see https://wiki.dti.ulaval.ca/pages/viewpage.action?spaceKey=MODUL&title=Gestion+des+erreurs
 */
export enum ControlValidatorValidationType {
    None = 'none',
    AtExit = 'at-exit',
    Correction = 'correction',
    Modification = 'modification',
    OnGoing = 'on-going'
}
